module.exports = __webpack_public_path__ + "img/icon-clipping-main.a75816a.svg";